import InventoryListingTitle from './InventoryListingTitle';
export default InventoryListingTitle;